import { useTranslation } from "react-i18next";
import { EnrollmentStepWrapper } from "../../styles/Enrollment.styled";
import { Button } from "../../styles/Button.styled";
import { iCheckConfig, CONSTELLATION_UTIL_MAPPING,REFERER_URL } from "../../../config";
import { useContext, useEffect, useState } from "react";
import { CheckboxItem } from "../../CheckboxItem";
// import { toast } from 'react-toastify';
import {
  getEnrollmentRecord,
  saveEnrollmentPaymentInfo,
} from "../../../fetch/enrollment";
import { FormLoading } from "../../FormLoading";
import { EnrollmentContext } from "./enrollment";
import { useLocation, useNavigate } from "react-router-dom";
import { PhoneNumbers, pushToDataLayer } from "../../data";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { Address, EnrollmentFields, PlanProps } from "../../../types";
import qs from "qs";
import { LoadingRow } from "../../LoadingRow";

interface Props {
  show: boolean;
  result: any;
  name: string;
  email: string;
  enrollmentId: string;
  sign: string;
}

export const EnrollmentStepConfirmation: React.FC<Props> = ({
  result,
  show,
  name,
  email,
  enrollmentId,
  sign,
}) => {
  const { promoCode, utility, serviceAddress, selectedProduct } =
    useContext(EnrollmentContext);
    const location = useLocation();
  useEffect(() => {
    if (!show) return;
    if (result) {
      const { additional, message, status, record_identifier } = result;
      let errorCode = status.split(".")[0];
      // const dataStatus = errorCode === "10"  ? 'Complete'  :  errorCode === "20" ? "Deposit" :'Rejected';
      // pushToDataLayer({
      //   event: "enrollment_order_complete",
      //   zip_code: utility?.zipcode,
      //   user_region:utility?.state_id ? utility.state_id : "TX",
      //   provider:
      //     //@ts-ignore
      //     CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
      //     utility?.utility_code,
      //   electricity_plan_rate: selectedProduct.price1000,
      //   electricity_plan_term: selectedProduct.contract_term,
      //   electricity_termination_fee: selectedProduct.cancel_fee,
      //   offer_code: localStorage.getItem("promoCode"),
      //   confirmation_number: additional && additional[0]?.customer_id ? additional[0]?.customer_id : '',
      //   esiid:serviceAddress[0].esiid,
      //   referrer_url: `${REFERER_URL}${location.search}`,
      //   Status: dataStatus,
      // });
      if (errorCode === "10") {
        window.digitalData.page.pageInfo.pageName = "Order Confirmation";
      } else {
        window.digitalData.page.pageInfo.pageName = "Order Failed";
      }
    }
  }, [show]);
 
  const showResult = () => {
    if (result) {
      const { additional, message, status, record_identifier } = result;
      let errorCode = status.split(".")[0];
      switch (errorCode) {
        case "10":
          return (
            <Successful
              promoCode={promoCode}
              utility={utility}
              sign={sign}
              message={message}
              serviceAddress={serviceAddress}
              enrollmentId={enrollmentId}
              email={email}
              selectedProduct={selectedProduct}
            />
          );
        case "20":
          return <Rejected promoCode={promoCode} message={message} />;
          // return (
          //   <PendingDeposit
          //     promoCode={promoCode}
          //     additional={additional}
          //     name={name}
          //   />
          // );
        case "30":
          return (
            <PendingVerification
              promoCode={promoCode}
              message={message}
              additional={additional}
            />
          );
        case "40":
          return <ContactLater promoCode={promoCode} />;
        case "50":
          return <Rejected promoCode={promoCode} message={message} />;
        default:
          return null;
      }
    }
    return null;
  };

  if (!show) return null;
  return (
    <EnrollmentStepWrapper>
      <div className="p-4">{showResult()}</div>
    </EnrollmentStepWrapper>
  );
};

const Successful = ({
  promoCode,
  sign,
  utility,
  message,
  serviceAddress,
  enrollmentId,
  email,
  selectedProduct,
}: {
  promoCode: string;
  sign: string;
  utility: any;
  message: string;
  serviceAddress: Address[];
  enrollmentId: string;
  email: string;
  selectedProduct: PlanProps;
}) => {
  const { t } = useTranslation("enrollment");
  const navigate = useNavigate();
  const location = useLocation();
  // Todo: Fix this
  const customerId = message.split(":")[1];
  const { esiid, street, zipcode, city, state } = serviceAddress[0];
  const [loading, setLoading] = useState(false);
  const [reviewData, setReviewData] = useState<EnrollmentFields | undefined>(
    undefined
  );

  // console.log('enrollmentResult', enrollmentResult?.total?.response_vail.CustomerResponse.CustomerID)

  // console.log('CustomerId',customerId)
  useEffect(() => {
    if (enrollmentId) {
      getEnrollmentRecord(enrollmentId, sign).then((res: any) => {
        if (res && parseInt(res.status) === 1) {
          setReviewData(res.response);
          setLoading(false);
        }
      });
    }
  }, []);

  function createData(name: string, content: any) {
    return { name, content };
  }
  const formatDate = (dateString: string | undefined) => {
    if (!dateString) {
      return;
    }
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };
  let rows = [
    createData("Your Constellation Customer ID", customerId),
    createData("Your Service Address", `${street} ${city} ${state} ${zipcode}`),
    createData(
      "Your Requested Move Date",
      formatDate(reviewData?.requested_date)
    ),
    createData("Your Electricity Utility(TDSP)", utility?.utility_name),
    createData("Plan Name", selectedProduct.plan_name),
    createData("Rate (Based on 1,000 kWh)", `${selectedProduct.price1000}¢`),
    createData("Plan Length", `${selectedProduct.contract_term} Months`),
    createData("Promo Code", promoCode),
  ];
  if (loading)
    return (
      <div className="pt-5 pb-5">
        <LoadingRow />
      </div>
    );
  return (
    <div>
      <div className="text-center">
        <h1>Your order has been submitted. Thank you!</h1>
        <p>
          We've received your order. When your order is complete, we'll send a
          detailed confirmation email to {email}. If you don't receive your
          email within 24 hours, please contact us at home@constellation.com or
          by phone at {PhoneNumbers[promoCode]}.
        </p>

        <TableContainer component={Paper}>
          <p
            style={{
              textAlign: "center",
              background: "#33669f",
              margin: "0",
              padding: "10px 0",
              color: "#fff",
              fontWeight: 500,
              fontSize: "20px",
            }}
          >
            Your Electricity Order Details
          </p>
          <Table aria-label="simple table">
            <TableBody>
              {rows.map((row: any) => (
                <TableRow
                  key={row.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    align="center"
                    style={{
                      background: "#cde4f9",
                      fontWeight: 600,
                      color: "#33669f",
                    }}
                  >
                    {row.name}
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{ background: "#f0f8fd", color: "#33669f" }}
                  >
                    {row.content}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="mt-5">
          <Button
            withArrow
            onClick={() => {
              navigate(`/${location.search}`);
            }}
          >
            Close the Window
          </Button>
        </div>
        {/* <div className="mt-5">
                    <Button secondary
                        onClick={() => {
                            window.location.reload();
                        }}>
                        {t('Close the Window')}
                    </Button>
                </div> */}
      </div>
    </div>
  );
};

const Rejected = ({
  promoCode,
  message,
}: {
  promoCode: string;
  message: string;
}) => {
  const { t } = useTranslation("enrollment");
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div>
      <div className="text-center">
        <h1>{t("Your application was not approved")}</h1>
        {/* <div>
                    Unfortunately your application is not approved by the selected Retail Energy
                    Provider (REP) at this time. Please try another REP or{' '}
                    <a href="tel:855-411-0497" style={{color:'#2372B9'}}>contact us</a>{' '}
                    for more prepaid plans.
                </div> */}
        <p>{t(message)}</p>
        <p>Promo Code: {promoCode}</p>
        <div className="mt-4">
          <Button
            onClick={() => {
              document.location.href = `tel:${PhoneNumbers[promoCode]}`;
            }}
          >
            Contact Us: {PhoneNumbers[promoCode]}
          </Button>
        </div>
        <div className="mt-5">
          <Button
            secondary
            onClick={() => {
              navigate(`/${location.search}`);
            }}
          >
            {t("Close the Window")}
          </Button>
        </div>
      </div>
    </div>
  );
};

const PendingDeposit = ({
  promoCode,
  additional,
  name,
}: {
  promoCode: string;
  additional: any;
  name: string;
}) => {
  const { t } = useTranslation("enrollment");
  const [paymentMethod, setPaymentMethod] = useState("1");
  const [showSuccessfulPage, setShowSuccessfulPage] = useState(false);
  const [paymentResponse, setPaymentResponse] = useState();
  const [saving, setSaving] = useState(false);
  const { handleSetErrorModalContent } = useContext<any>(EnrollmentContext);

  const depositAmount =
    additional && additional[0] && additional[0].deposit_amount
      ? additional[0].deposit_amount
      : 0;
  const recordId =
    additional && additional[0] && additional[0].record_identifier
      ? additional[0].record_identifier
      : "";
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("message", handleMessage);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("message", handleMessage);
      }
    };
  }, []);

  const handleMessage = (e: any) => {
    const jsonData = e.data;
    // console.log(jsonData)
    if (typeof jsonData !== "undefined") {
      if (
        typeof jsonData === "object" &&
        jsonData.constructor.name === "Object"
      ) {
        const { source } = jsonData;
        if (typeof source !== "undefined" && source === "iCheck") {
          if (
            typeof jsonData.error !== "undefined" &&
            jsonData.error !== null
          ) {
            // toast.error(jsonData.error);
            handleSetErrorModalContent({
              title: jsonData.error,
            });
          } else {
            setPaymentResponse(jsonData);
            setSaving(true);
            const { transactionResponse } = jsonData;
            if (transactionResponse.indexOf("APPROVED") >= 0) {
              saveEnrollmentPaymentInfo(
                recordId,
                JSON.stringify(jsonData)
              ).then((res) => {
                setSaving(false);
                if (res && parseInt(res.status) === 1) {
                  setShowSuccessfulPage(true);
                } else {
                  handleSetErrorModalContent({
                    title: t("UnknownError"),
                  });
                  // toast.error(t('UnknownError'))
                }
              });
            } else {
              setSaving(false);
              handleSetErrorModalContent({
                title: transactionResponse.split("|")[0],
              });
              // toast.error(transactionResponse.split('|')[0]);
            }
          }
        }
      }
    }
  };

  const getAdditionalContent = () => {
    const { ccUrl, baUrl, appId, appSecret, styles } = iCheckConfig;
    const url = paymentMethod === "1" ? ccUrl : baUrl;

    return (
      <div style={{ marginTop: 12 }}>
        <p>Promo Code: {promoCode}</p>
        <p style={{ fontSize: 18 }}>
          <b>
            Deposit Amount:{" "}
            <span style={{ color: "#2372B9", fontSize: 20 }}>
              ${depositAmount}
            </span>
          </b>
        </p>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div className="d-flex justify-content-center">
            <CheckboxItem
              label="Credit Card"
              value="1"
              checked={paymentMethod === "1"}
              isRadio
              disabled={false}
              handleClick={() => setPaymentMethod("1")}
            />
            <CheckboxItem
              label="eCheck (ACH)"
              value="2"
              checked={paymentMethod === "2"}
              isRadio
              disabled={false}
              handleClick={() => setPaymentMethod("2")}
            />
          </div>
        </div>
        <iframe
          id="iFrameICG"
          name="iFrameICG"
          src={`${url}?appId=${appId}&appSecret=${appSecret}&custId=${recordId}&amount=${depositAmount}&firstName=${
            name.split(" ")[0]
          }&lastName=${name.split(" ")[1]}&css=${styles}`}
          frameBorder="0"
          scrolling="no"
          width="360"
          height="560"
        />
      </div>
    );

    // return additional.map((val: any, idx: number) => {
    //     return (
    //         <div className="mb-2">
    //             <Button
    //                 key={idx}
    //                 onClick={() => {
    //                     if (val.value.indexOf('http') === 0) {
    //                         if (typeof window !== undefined) {
    //                             window.open(val.value, '_blank')
    //                         }
    //                     } else {
    //                         document.location.href = `tel:${val.value}`
    //                     }
    //                 }}>
    //                 {t(val.label)}
    //             </Button>
    //         </div>
    //     )
    // })
  };

  if (showSuccessfulPage) {
    return (
      <div>
        <div className="text-center">
          <h1>Welcome to Constellation!</h1>
          <p>
            Your enrollment request has been received. Please wait for an email
            confirmation from Constellation including the plan details and your
            next steps. Additional information may be required to start your
            services. Thank you for choosing Constellation.
          </p>
          <p>Your Customer ID: {additional?.[0]?.customer_id}</p>
          <p>Create your account now</p>
          <div className="mt-5">
            <Button
              withArrow
              onClick={() => {
                navigate("/");
              }}
            >
              MyAccount
            </Button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className="text-center">
        <h1>{t("We are almost there!")}</h1>
        <p>
          You are almost there! To complete your enrollment, please pay the
          deposit via credit card or bank account.
        </p>
        {/* <div className="mt-5">{getAdditionalContent()}</div> */}
      </div>
      <div className="mt-5">
        <h5>{t("Why should I pay the deposit?")}</h5>
        <p>
          A deposit is required by Constellation after careful review of your
          credit history. Your payment information will be sent to Constellation
          to process your deposit and will not be stored, used, or shared by
          Constellation.
        </p>
      </div>
      <FormLoading show={saving} />
    </div>
  );
};

const PendingVerification = ({
  promoCode,
  message,
  additional,
}: {
  promoCode: string;
  message: string;
  additional: any;
}) => {
  const { t } = useTranslation("enrollment");

  const getAdditionalContent = () => {
    return additional.map((val: any, idx: number) => {
      return (
        <div className="mb-2" key={idx}>
          <Button
            key={idx}
            onClick={() => {
              if (val.link.indexOf("http") === 0) {
                if (typeof window !== undefined) {
                  window.open(val.link, "_blank");
                }
              } else {
                document.location.href = `tel:${val.link}`;
              }
            }}
          >
            {t(val.label)}
          </Button>
        </div>
      );
    });
  };

  return (
    <div>
      <div className="text-center">
        <h1>{t("Pending verification by Constellation")}</h1>
        <p>
          {t(
            "Constellation is verifying some of your information and it might take a little longer. We will send an email to inform you of the decision."
          )}
        </p>
        <p>{t(message)}</p>
        <p>Your Customer ID: {additional?.[0]?.customer_id}</p>
        <div className="mt-4">
          <Button
            onClick={() => {
              document.location.href = `tel:${PhoneNumbers[promoCode]}`;
            }}
          >
            Contact Us: {PhoneNumbers[promoCode]}
          </Button>
        </div>
        <div className="mt-5">
          {/* {getAdditionalContent()} */}
          <Button
            secondary
            onClick={() => {
              window.location.reload();
            }}
          >
            {t("Close the Window")}
          </Button>
        </div>
      </div>
    </div>
  );
};

const ContactLater = ({ promoCode }: { promoCode: string }) => {
  const { t } = useTranslation("enrollment");
  return (
    <div>
      <div className="text-center">
        <h1>{t("Pending Review")}</h1>
        <p>
          {t(
            `There appears to be an issue with the payment process. For further assistance, please contact ${PhoneNumbers[promoCode]}.`
          )}
        </p>
        <div className="mt-4">
          <Button
            onClick={() => {
              document.location.href = `tel:${PhoneNumbers[promoCode]}`;
            }}
          >
            Contact Us: {PhoneNumbers[promoCode]}
          </Button>
        </div>
        <div className="mt-5">
          <Button
            secondary
            onClick={() => {
              window.location.reload();
            }}
          >
            {t("Close the Window")}
          </Button>
        </div>
      </div>
    </div>
  );
};
